// 多式联运报表路由
const reportForms = {
  path: '/intermodality',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'receivables1',
      name: 'receivables1',
      component: () => import('@/pages/intermodality/reportForms/receivables.vue'),
      meta: {
        keepAlive: true,
        title: '应收账款明细表',
      },
    },
    {
      path: 'accountsPayable',
      name: 'accountsPayable',
      component: () => import('@/pages/intermodality/reportForms/accountsPayable.vue'),
      meta: {
        keepAlive: true,
        title: '应付账款明细表',
      },
    },
  ],
};

export default reportForms;
